import { render, staticRenderFns } from "./ReviewBoosterTagsSelector.vue?vue&type=template&id=728dc07b&scoped=true&"
import script from "./ReviewBoosterTagsSelector.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterTagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterTagsSelector.vue?vue&type=style&index=0&id=728dc07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728dc07b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
